import { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../../api/quarkusApi';

export function useUsers() {
  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUsers = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get('/configuration/clinic-users', {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .then((returnFromApi) => setUsers(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.response?.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return { users, isLoading, error, refetch: fetchUsers };
}
